import { apiClient } from './client'

/** SMTP settings as returned by the admin email settings endpoints. */
export interface EmailSettings {
  enabled: boolean
  smtp_host: string
  smtp_port: number
  smtp_use_tls: boolean
  smtp_username: string
  from_address: string
  public_url: string
  /** True when a password is stored; the password itself is never returned. */
  has_password: boolean
  /** True when the stored row could not be decrypted and must be re-entered. */
  unreadable: boolean
}

/** Body for `PUT /settings/email`; a blank `smtp_password` keeps the stored one. */
export type EmailSettingsUpdate = Omit<EmailSettings, 'has_password' | 'unreadable'> & {
  smtp_password: string
}

/** Result of `POST /settings/email/test`; returned with 200 even when not sent. */
export interface EmailTestResult {
  sent: boolean
  error: string | null
}

export const emailApi = {
  /** Load the stored SMTP settings (admin only). */
  get: async (): Promise<EmailSettings> => (await apiClient.get('/settings/email')).data,

  /** Save SMTP settings and return them as stored. */
  save: async (data: EmailSettingsUpdate): Promise<EmailSettings> =>
    (await apiClient.put('/settings/email', data)).data,

  /** Send a test email with the saved settings to `to`. */
  test: async (to: string): Promise<EmailTestResult> =>
    (await apiClient.post('/settings/email/test', { to })).data,
}
